<template>
  <v-card class="pa-4" :class="{ 'error-scroller': error }">
    <p class="title mb-1">{{ $t('campanhas.publico_alvo') }}</p>
    <p class="primary-text">{{ $t('campanhas.segmento_ja_criado') }}</p>
    <tooltip fit-content align="right" :disabled="!isIndustryCampaign" :message="tooltipMessage">
      <publico-alvo
        :segmentos.sync="segmentsLocal"
        :error="error"
        :is-offer-schedule-personalized="isOfferSchedulePersonalized"
        :disable="disabled"
        disable-segment-view
      />
    </tooltip>
  </v-card>
</template>

<script>
export default {
  components: {
    PublicoAlvo: () => import('@/modules/campanhas/views/components/PublicoAlvo.vue'),
    Tooltip: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'),
  },
  props: {
    segments: Array,
    error: Boolean,
    isOfferSchedulePersonalized: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    segmentsLocal: {
      get() {
        return this.segments
      },
      set(value) {
        this.$emit('update:segments', value)
      },
    },
  },
}
</script>
